import {showNotification} from 'platform/components';

import {isNil} from 'ramda';

import i18n from '@dms/i18n';
import {testIds} from '@dms/routes';
import {DmsDataGrid, downloadDataGridExport, refreshDmsDatagrid} from '@dms/shared';

import {parseDate} from 'shared/web';

import {formatDataGridExportDate, type ActionCallback} from 'features/eag-grid';

import {MyProfileTemplate} from '../../components/MyProfileTemplate/MyProfileTemplate';

const EXPORT_COLUMNS = ['dataGridCode', 'exportedAt', 'exportId'] as const;

export function TableExports() {
  const actionCallback: ActionCallback<typeof EXPORT_COLUMNS> = ({
    actionKey,
    rowId,
    getColumnData,
  }) => {
    const exportId = Array.isArray(rowId) ? rowId[0] : rowId;

    if (actionKey !== 'download') {
      return;
    }

    const sourceGridCode = getColumnData<{key: string; label: string}>('dataGridCode')?.value?.key;
    const createdAt = getColumnData<string>('exportedAt')?.value;

    if (isNil(sourceGridCode)) {
      showNotification.error();
      return;
    }

    const exportedAt = createdAt ? formatDataGridExportDate(parseDate(createdAt)) : '';
    return downloadDataGridExport({exportId, gridCode: sourceGridCode, exportedAt});
  };

  return (
    <MyProfileTemplate
      header={{
        title: i18n.t('page.myProfile.labels.tableExports'),
        actions: [
          {
            type: 'button',
            variant: 'secondary',
            leftIcon: 'navigation/refresh',
            title: i18n.t('general.actions.refresh'),
            onClick: () => refreshDmsDatagrid('data-grid-export'),
          },
        ],
        breadcrumbs: [
          {label: i18n.t('entity.user.labels.myProfile'), isCurrentPage: true},
          {label: i18n.t('page.myProfile.labels.tableExports'), isCurrentPage: true},
        ],
      }}
    >
      <DmsDataGrid
        gridCode="data-grid-export"
        actionCallback={actionCallback}
        predefinedColumns={EXPORT_COLUMNS}
        data-testid={testIds.myProfile.tableExports('datagrid')}
      />
    </MyProfileTemplate>
  );
}
